import { IHoldingMessageProps } from './HoldingMessage';

export const WebCMSHoldingInfo: IHoldingMessageProps = {
  title: 'Website Content Management',
  sections: [
    {
      heading: 'What is Website Content Management?',
      body: 'The website content management functionality provides the ability to manage content for an OGL eShop website within Profit4. This feature also provides a full and seamless integration between Profit4 and the OGL eShop website, eliminating the need for data duplication and ensuring that all information is up-to-date.',
    },
    {
      heading: 'What are the benefits of a fully integrated OGL eShop website?',
      bulletPoints: [
        'User-friendly CMS, quickly make edits directly in Profit4',
        'SEO friendly (appear in Google searches)',
        'Fast & secure hosting',
        'Stock levels & product info auto-updated',
        'Customer accounts with tailored pricing &/or loyalty points',
        'Built-in payment processing',
        'Automated order processing',
        'Integrated couriers',
        'Automated customer order & tracking updates',
        'Google Analytics 4 & Google Search Console setup',
        'Enterprise-grade cyber security',
      ],
    },
  ],
};
